module.exports = __webpack_public_path__ + "img/choose3.b10e2c64.png";